import { Box, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { hideNoInternetPopUp } from '../../store/reducers/appSlice';
import NoInternetIcon from '../icons/no-internet';
import { NoInternetModalUI } from './nointernet-style';

const NoInternetPopUp = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const { isShowNoInternetPopup } = useSelector((state: RootState) => state?.app);

    const closePopup = () => {
        dispatch(hideNoInternetPopUp());
    };
    return (
        <NoInternetModalUI
            open={isShowNoInternetPopup}
            onClose={closePopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="changePassword"
        >
            <DialogContent>
                <Box height="100%" width="100%" justifyContent="center" display="flex" flexDirection="column">
                    <Box sx={{ alignSelf: 'center' }}>
                        <NoInternetIcon />
                    </Box>
                    <Typography variant="h5" mb={0.6} className="header" textAlign="center" mt={1}>
                        {t('no_internet')}
                    </Typography>
                    <Typography variant="subtitle1" mb={1.5} className="header" textAlign="center">
                        {t('no_internet_msg')}
                    </Typography>
                </Box>
            </DialogContent>
        </NoInternetModalUI>
    );
};
export { NoInternetPopUp };
